import PropTypes from 'prop-types';
import { createContext } from 'react';

import useFetchData from 'src/hooks/useFetchData';
import LoadingScreen from 'src/components/LoadingScreen';

const ColorsContext = createContext();

export const ColorsProvider = ({ children }) => {
  const { result, loading } = useFetchData({
    path: '/colors',
    auth: true
  });

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <ColorsContext.Provider value={{ ...result.data }}>
      {children}
    </ColorsContext.Provider>
  );
};

ColorsProvider.propTypes = {
  children: PropTypes.element.isRequired
};

export default ColorsContext;
